<template>
  <div class="system-sign-up-modal">
    <div class="modal-header">
      <span>查看报名信息</span>
      <i class="close" @click="cancel"></i>
    </div>
    <div class="modal-content">
      <slot></slot>
      <a class="down-signup-word-btn" v-if="signInfoRes.participateProgress == '102'
      ||signInfoRes.participateProgress == '103'
      ||signInfoRes.participateProgress == '104'
      ||signInfoRes.participateProgress == '105'
      ||signInfoRes.participateProgress == '1011'" 
      target="_blank" :href="'http://47.97.86.254:9999/api/u-portal/act/award/downloadSignUpWord?id='+signInfoRes.signUpId">下载申报表原件</a>       
    </div>
    <div class="modal-footer">
      <button class="cancel" @click="cancel">关闭</button>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
    }
  },
  props: {    
    signInfoRes:Object
  },
  mounted(){
    console.log(this.tabActive);
  },
  methods: {
    cancel() {
      this.$emit('cancel');
    }
  }
}
</script>

<style lang="less">
.system-sign-up-modal {
  width: 70vw;
  background: #FFFFFF;
  padding: 30px 0;
  box-shadow: 0px 2px 10px 0px rgba(0,0,0,0.0600);

  .modal-header {
    font-size: 20px;
    font-family: PingFang-SC-Bold, PingFang-SC;
    font-weight: bold;
    color: #333333;
    text-align: center;
    margin-bottom: 40px;
    position: relative;

    i {
      cursor: pointer;
      width: 20px;
      height: 20px;
      background: url(../../../assets/images/icon-close.png) no-repeat center center;
      background-size: 100% 100%;
      position: absolute;
      right: 20px;
      top: 0;
    }
  }

  .modal-content {
    height: 70vh;
    overflow: auto;
    margin-bottom: 20px;

    .dynamic-form {
      .tab-wrap {
        padding-left: 50px;
        padding-right: 50px;
      }
    }
    .down-signup-word-btn{
      margin-left: 20px;
      cursor:pointer;
    }
  }

  .modal-footer {
    display: flex;
    align-items: center;
    justify-content: center;

    button {
      width: 120px;
      height: 40px;
      font-size: 16px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      outline: none;
      border: none;
      cursor: pointer;

      &.cancel {
        margin-right: 20px;
        color: #06AE63;
        background: rgba(6,174,99,0.1000);
      }

      &.confirm {
        background: #06AE63;
        color: #FFFFFF;
      }
    }
  }
}
</style>